import React, { createContext, useContext, useState, useEffect } from 'react';
import { settingsAPI } from '../services/api';

const SEOContext = createContext();

export const useSEO = () => {
  const context = useContext(SEOContext);
  if (!context) {
    throw new Error('useSEO must be used within SEOProvider');
  }
  return context;
};

export const SEOProvider = ({ children }) => {
  const [seoSettings, setSeoSettings] = useState({
    siteTitle: 'Kuran-ı Kerim',
    siteDescription: 'Kuran-ı Kerim okuyun ve dinleyin',
    metaKeywords: 'kuran, kuran-i kerim, meal, hafiz',
    ogTitle: 'Kuran-ı Kerim',
    ogDescription: 'Yuce Kuran\'ı okuyun ve dinleyin',
    ogImage: '',
    favicon: '',
    logo: '',
    headerLogoText: 'Kuran-ı Kerim',
    headerLogoUrl: 'www.kuranikerim.se'
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const response = await settingsAPI.get();
      if (response.data) {
        setSeoSettings({
          siteTitle: response.data.siteTitle || 'Kuran-ı Kerim',
          siteDescription: response.data.siteDescription || '',
          metaKeywords: response.data.metaKeywords || '',
          ogTitle: response.data.ogTitle || '',
          ogDescription: response.data.ogDescription || '',
          ogImage: response.data.ogImage || '',
          favicon: response.data.favicon || '',
          logo: response.data.logo || '',
          headerLogoText: response.data.headerLogoText || 'Kuran-ı Kerim',
          headerLogoUrl: response.data.headerLogoUrl || 'www.kuranikerim.se'
        });
      }
    } catch (error) {
      console.error('Error loading SEO settings:', error);
    } finally {
      setLoading(false);
    }
  };

  const refreshSettings = () => {
    loadSettings();
  };

  return (
    <SEOContext.Provider value={{ seoSettings, loading, refreshSettings }}>
      {children}
    </SEOContext.Provider>
  );
};
